import React, { useEffect }from 'react';
import { 
  BrowserRouter, 
  Routes, 
  Route, 
  useLocation
} from 'react-router-dom';
import Home from './routes/Home';
import About from './routes/About';
import Header from './partials/Header';
import Footer from './partials/Footer';
import Services from './routes/Services';
import Connect from './routes/Connect';
import Careers from './routes/Careers';
import Eng from './routes/careers/Eng';
import FreeSite from './routes/FreeSite';
import "@fontsource-variable/outfit";
import "@fontsource-variable/dm-sans";
import "@fontsource-variable/roboto-mono";
import './App.scss';

function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: "smooth" 
    });
  }, [pathname]);

  return null;
}


function App() {

  return (
    <div className="App">
      <BrowserRouter>
        <ScrollToTop />
        <Header />
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/services" element={<Services />} />
            <Route path="/connect" element={<Connect />} />
            <Route path="/careers" element={<Careers />} />
            {/* Career Openings */}
            <Route path="/careers/full-stack-engineer" element={<Eng />} />
            <Route path="/careers/open-role" element={<Eng />} />
            {/* Limited Time */}
            <Route path="/starter" element={<FreeSite />} />
          </Routes>
        <Footer/>
      </BrowserRouter>
    </div>
  );
}

export default App;
